module.exports = __webpack_public_path__ + "img/logo1 (19).df4e4320.jpg";